/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 10:43:06
 * @LastEditTime: 2021-06-25 11:31:24
 * @Description: 用户store
 */
import {
    getUserList,
    createUser,
    updateUser,
    adminChangeUserPassword,
    bannedUser,
    recover,
    adminResetUserPassword,
    getSimpleUserList
} from '@/api/user'
import Vue from 'vue'

const state = {
    userList: [],
    userOption: [], // 用于选择的
    totalCounts: 0,
    simpleUserList: [],
}

const getters = {
    getUserById: (state) => (id) => {
        return state.userList.find(x => x._id === id)
    },
}

const actions = {
    async getUsersAction({
        commit
    }, payload) {
        try {
            const user = await getUserList(payload)
            commit('SETUSER', user.data)
            return user.data
        } catch (error) {
            throw error.message
        }
    },
    async getSimpleUserListAction({
        commit
    }, payload) {
        try {
            const user = await getSimpleUserList(payload)
            commit('SET_SIMPLE_USER', user.data)
            return user.data
        } catch (error) {
            throw error.message
        }
    },
    async createUserAction({
        commit
    }, payload) {
        try {
            const newUser = await createUser(payload);
            commit('ADDNEWUSER', newUser.data)
            return newUser.data
        } catch (error) {
            throw error.message
        }
    },
    async updateUserAction({
        commit
    }, payload) {
        try {
            const newUser = await updateUser(payload.id, payload.data);
            commit('UPDATEUSER', newUser.data)
            return newUser.data
        } catch (error) {
            throw error.message
        }
    },
    async adminChangeUserPasswordAction({
        commit
    }, payload) {
        try {
            await adminChangeUserPassword(payload.id, payload.password);
        } catch (error) {
            throw error.message
        }
    },
    async bannedUserAction({
        commit
    }, {
        id
    }) {
        try {
            const newUser = await bannedUser(id)
            commit('UPDATEUSER', newUser.data)
            return newUser.data
        } catch (error) {
            throw error.message
        }
    },
    async recoverAction({
        commit
    }, {
        id
    }) {
        try {
            const newUser = await recover(id)
            commit('UPDATEUSER', newUser.data)
            return newUser.data
        } catch (error) {
            throw error.message
        }
    },
    async adminResetUserPasswordAction({
        commit
    }, id) {
        try {
            const {
                data
            } = await adminResetUserPassword(id)
            return data;
        } catch (error) {
            throw error.message
        }
    }
}

const mutations = {
    SETUSER(state, payload) {
        state.userList = payload.userList
        state.totalCounts = payload.totalCounts
    },
    SET_SIMPLE_USER(state, payload) {
        state.simpleUserList = payload.userList
    },
    ADDNEWUSER(state, user) {
        state.userList.unshift(user);
        state.totalCounts++
    },
    UPDATEUSER(state, user) {
        Vue.set(state.userList, state.userList.findIndex(x => x._id === user._id), user)
    },
    REMOVEUSER(state, userId) {
        state.currentUser = state.currentUser.filter((e) => e._id !== userId)
        state.stat.totalCounts--
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}